<template>
  <div
    id="post_back_log"
    class="card"
  >
    <b-card-header>
      <ps-filters
        v-model="filterValues"
        :filter-settings="filterSettings"
        :show-export="$hasPermission('export_postback_logs')"
        @search="search"
        @exportToCSV="exportToCSV"
      />
    </b-card-header>
    <div class="table-responsive mb-0">
      <table
        role="table"
        class="table b-table table-striped table-hover"
      >
        <thead
          role="rowgroup"
          class=""
        >
          <tr
            role="row"
            class=""
          >
            <th
              role="columnheader"
              aria-colindex="1"
              :aria-sort="arialSort('app_name')"
              @click="sortCol('app_name')"
            >
              {{ $t('logs.app') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="2"
              :aria-sort="arialSort('created_at')"
              @click="sortCol('created_at')"
            >
              {{ $t('logs.dateTime') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('type')"
              @click="sortCol('type')"
            >
              {{ $t('apps.type') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('reward')"
              @click="sortCol('reward')"
            >
              {{ $t('logs.reward') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('payout')"
              @click="sortCol('payout')"
            >
              {{ $t('logs.payout') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('postback_url')"
              @click="sortCol('postback_url')"
            >
              {{ $t('logs.postbackUrl') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('status_code')"
              @click="sortCol('status_code')"
            >
              {{ $t('logs.statusCode') }}
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <template v-for="(rowTr, indextr) in items">
            <tr
              :key="indextr"
              :class="rowTr.class"
            >
              <td>
                {{ rowTr.app_name }}
              </td>
              <td>
                {{ rowTr.created_at }}
              </td>
              <td>
                {{ systemLabel(rowTr.type) }}
              </td>
              <td>
                {{ rowTr.reward }}
              </td>
              <td>
                {{ rowTr.payout | formatCurrency }}
              </td>
              <td>
                {{ rowTr.postback_url }}
              </td>
              <td>
                {{ systemLabel(rowTr.status_code) }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <b-card-footer>
      <b-row>
        <b-col
          v-show="items.length > 0"
          cols="12"
        >
          <pagination-and-table-info
            :data="paginationData"
            @change="handleChangePage($event)"
          />
        </b-col>
        <b-col
          v-show="items.length === 0"
          cols="12"
          style="font-weight: 500; text-align: center"
        >
          {{ $t('apps.noData') }}
        </b-col>
      </b-row>
    </b-card-footer>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'
import { systemLabel } from '@/libs/i18n/display'

import PaginationAndTableInfo from '@ps_main/custom-components/PaginationAndTableInfo.vue'
import PsFilters from '@/main/custom-components/PsFilters.vue'

export default {
  components: {
    PsFilters,
    PaginationAndTableInfo,
  },
  data() {
    return {
      url: '/api/logs/postback-log',
      items: [],
      filterValues: {},
      filterSettings: {
        dateRange: {
          type: 'daterange',
          get label() { return i18n.t('logs.fromTo') },
          class: 'mr-2 mb-0',
          style: '',
          data: [],
          defaultValue: {
            fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            toDate: new Date(),
          },
          postKey: 'dateRange',
          'label-cols': 2,
        },
        type: {
          type: 'select',
          get label() { return i18n.t('apps.type') },
          class: 'mr-2 mb-0',
          data: [
            { value: 0, get text() { return i18n.t('logs.allTypes') } },
            { value: 1, get text() { return i18n.t('apps.complete') } },
            { value: 2, get text() { return i18n.t('apps.screenout') } },
            { value: 3, get text() { return i18n.t('apps.bonus') } },
            { value: 4, get text() { return i18n.t('apps.reconciliation') } },
            { value: 5, get text() { return i18n.t('logs.offerCompleted') } },
            { value: 6, get text() { return i18n.t('logs.preQualificationReward') } },
            { value: 7, get text() { return i18n.t('logs.pending') } },
            { value: 8, get text() { return i18n.t('logs.pendingReconciled') } },
          ],
          defaultData: { value: 0, get text() { return i18n.t('logs.allTypes') } },
          defaultValue: 0,
          'label-cols': 3,
        },
      },
      params: {
        page: 1,
        orderBy: 'id',
        itemPerPage: 10,
        orderDirection: 'DESC',
      },
      pageTotal: 0,
      totalItems: 0,
      responseData: null,
    }
  },
  computed: {
    paginationData() {
      return this.laravelPaginationPages(this.responseData)
    },
  },
  created() {
    // this.search()
  },
  methods: {
    systemLabel,
    handleChangePage(page) {
      this.params.page = page
      this.search()
    },
    sortCol(fieldName) {
      if (this.params.orderBy === fieldName) {
        this.params.orderDirection = this.params.orderDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.params.orderBy = fieldName
        this.params.orderDirection = 'asc'
      }
      this.search()
    },
    arialSort(sortFieldName) {
      if (this.params.orderBy === sortFieldName) {
        return this.params.orderDirection === 'asc'
          ? 'ascending'
          : 'descending'
      }
      return 'none'
    },
    search() {
      this.showLoading()
      this.$http
        .get(`${this.url}/get`, {
          params: {
            ...this.params,
            ...this.filterValues,
          },
        })
        .then(response => {
          this.items = response.data.data
          this.itemsTotal = response.data.total
          this.responseData = response.data
        })
        .catch(errors => {
          this.items = []
          this.responseData = null
          this.alertApiError(errors, i18n.t('logs.postbackLogRequestFailed'))
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    exportToCSV() {
      const exportLocale = i18n.locale
      this.isBusy = true
      this.showLoading()
      this.$http
        .get(`${this.url}/export`, {
          params: {
            ...this.params,
            ...this.filterValues,
            locale: exportLocale,
            only_file_name: true,
          },
        })
        .then(response => {
          const filename = response.data

          return this.$http
            .get(`${this.url}/export`, {
              params: {
                ...this.params,
                ...this.filterValues,
                locale: exportLocale,
              },
              responseType: 'blob',
            })
            .then(responseExport => {
              const url = window.URL.createObjectURL(new Blob([responseExport.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()
            })
            .catch(errors => {
              this.alertApiError(errors, i18n.t('logs.postbackLogExportFailed'))
            })
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('logs.postbackLogExportFailed'))
        })
        .finally(() => {
          this.hideLoading()
          this.isBusy = false
        })
    },
  },
}
</script>
